import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CerrixTextInputBase } from "../cerrix-textinput/cerrix-textinput-base";
import { CerrixTextAreaComponent } from "../cerrix-textinput/cerrix-textarea/cerrix-textarea.component";

@Component({
    selector: "cerrix-textarea-with-autohide",
    templateUrl: "./cerrix-textarea-with-autohide.component.html",
    styleUrls: ["./cerrix-textarea-with-autohide.component.scss"],
    imports: [FormsModule, CerrixTextAreaComponent],
})
export class CerrixTextareaWithAutohideComponent implements OnInit {
    @Input() disabled = false;
    @Input() placeholder = "";
    @Input() noValuePlaceholder = "-";
    @Input() editButtonText = "Edit";
    @Input() required = false;
    @Input() showFullText = false;

    _value = "";

    @Input()
    set value(value: string) {
        if (this._value === value) {
            return;
        }
        this.valueChanged = true;

        this._value = value;
        this.valueChange.emit(value);
    }
    get value(): string {
        return this._value;
    }

    @Output() valueChange = new EventEmitter<string>();
    @Output() valueChangeCompleted = new EventEmitter<string>();

    @ViewChild("cerrixInput") cerrixInput: CerrixTextInputBase;

    private valueChanged: boolean = false;
    showEditMode = false;

    ngOnInit(): void {
        if (!this.value && !this.disabled) {
            this.showEditMode = true;
        }
    }

    enableEditMode() {
        if (this.disabled) {
            return;
        }

        this.showEditMode = true;
        setTimeout(() => {
            this.cerrixInput.inputField.nativeElement.focus();
        }, 10);
    }

    onBlur() {
        if (this.value) {
            this.showEditMode = false;
        }
        if (this.valueChanged) {
            this.valueChangeCompleted.emit(this.value);
            this.valueChanged = false;
        }
    }
}
